import * as ActionTypes from "../action-types";

const company_defaultState = {
  byID: {},
  byCOID: {},
  allIDs: [],
};

export const company = (state = company_defaultState, action) => {
  let newState = JSON.parse(JSON.stringify(state));
  if (!action) return newState;
  switch (action.type) {
    case ActionTypes.COMPANY_GET_ALL: {
      const companies = action.company;

      companies &&
        companies.length &&
        companies.map((company) => {
          const { coid } = company;
          newState.byID[coid] = company;

          if (!newState.allIDs.includes(coid)) newState.allIDs.push(coid);
          return null;
        });
      return newState;
    }
    case ActionTypes.CREATE_COMPANY: {
      const companies = action.company;

      const { coid } = companies;

      if (coid) {
        newState.byID[coid] = companies;
      }

      return newState;
    }
    case ActionTypes.UPDATE_COMPANY: {
      const companies = action.company;

      const { coid } = companies;

      if (coid) {
        newState.byID[coid] = { ...newState.byID[coid], ...companies };
      }

      return newState;
    }
    case ActionTypes.GET_COMPANY_THRU_COID: {
      const company = action.company;

      newState.byCOID = company;

      return newState;
    }
    case ActionTypes.UPDATE_REMARKCOUNT_COMPANY: {
      const remark = action.remark;

      const { refid, remarkCount } = remark;

      if (refid) {
        newState.byID[refid] = {
          ...newState.byID[refid],
          remarkCount: remarkCount,
        };
      }

      return newState;
    }
    default: {
      return state;
    }
  }
};
